import { Injectable } from '@angular/core';
import { Observable,Subject} from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionCountdownService {

    countdown: string | undefined;
    secondToExpire : number | undefined;

    saveInvoiceDraft: Subject<boolean> = new Subject<boolean>();
    makeSessionAlert: Subject<boolean> = new Subject<boolean>();

    constructor( private router: Router) { 
    }


    getCountdown(){
      
    }

    setCountdown( countdown: string){
      this.countdown= countdown;
      this.rebuildSeconds();
    }

    rebuildSeconds(){
      let tmp=this.countdown!.split(':').map(Number);
      this.secondToExpire=(tmp[0]*60+tmp[1]);

      if( this.secondToExpire <= 0 ){
        this.router.navigate(['../Login']);
      }
      // se manca un minuto allora controllo se non sono in  url=="/main/invoices/new" || url=="/main/invoices/edit"
      if(this.secondToExpire <=60){
          //emetto evento NotificaSessioneInScadenza
          this.makeSessionAlert.next(true);
      }
      if(this.secondToExpire <=30){
        if((this.router.url=="/main/invoices/new") || (this.router.url=="/main/invoices/edit")){
          //emetto evento SalvaBozza
          this.saveInvoiceDraft.next(true);
        }
      }
    }

    getSecondToExpire(){
        return this.secondToExpire;
    }


    
  }
